export default __webpack_public_path__ + "static/media/Warning.6571580f.svg";